export default "__VITE_ASSET__edb77596__"